// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"194":"bc624316","417":"9be2cef7","560":"76f7d766","874":"2c27bf00","883":"3dab6ec2"}[chunkId] + ".css";
};